module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp--dark-74f5cc2a5aa01b80ba3a6d3443945106.png";